module.exports = __webpack_public_path__ + "img/keyboard_4.8e547a01.png";